'use es6';

import getIn from 'transmute/getIn';
import { NEW_UTK, NEW_VID, THREAD_ID } from '../constants/keyPaths';
const getContactAssociationVid = getIn(NEW_VID);
export const getUtk = getIn(NEW_UTK);
export const getThreadId = getIn(THREAD_ID);
export const getVid = message => {
  return getContactAssociationVid(message);
};